import { datatype, random } from "faker/locale/en_US";

import type { Campaign, DealCampaign } from "../../../types";
import type { Db } from "./types";

export const generateCampaigns = (_db: Db): Campaign[] => {
  return [
    {
      id: 0,
      name: "GC Ed. 300 — Mar/2026",
      tipo: "edicao",
      revista: "Grandes Culturas",
      data_inicio: "2026-03-01",
      data_fim: "2026-03-31",
      archived_at: null,
    },
    {
      id: 1,
      name: "Máquinas Ed. 260 — Abr/2026",
      tipo: "edicao",
      revista: "Máquinas",
      data_inicio: "2026-04-01",
      data_fim: "2026-04-30",
      archived_at: null,
    },
    {
      id: 2,
      name: "HF Ed. 160 — Mai/2026",
      tipo: "edicao",
      revista: "Hortaliças e Frutas",
      data_inicio: "2026-05-01",
      data_fim: "2026-05-31",
      archived_at: null,
    },
    {
      id: 3,
      name: "Site Mar–Jun/2026",
      tipo: "periodo",
      revista: null,
      data_inicio: "2026-03-01",
      data_fim: "2026-06-30",
      archived_at: null,
    },
    {
      id: 4,
      name: "Agrishow 2026",
      tipo: "evento",
      revista: null,
      data_inicio: "2026-04-27",
      data_fim: "2026-05-01",
      archived_at: null,
    },
  ];
};

export const generateDealCampaigns = (db: Db): DealCampaign[] => {
  const dealCampaigns: DealCampaign[] = [];
  let nextId = 0;

  db.deals.forEach((deal) => {
    const count = datatype.number({ min: 0, max: 2 });
    const selectedCampaigns = random.arrayElements(db.campaigns, count);
    selectedCampaigns.forEach((campaign) => {
      dealCampaigns.push({
        id: nextId++,
        deal_id: deal.id,
        campaign_id: campaign.id,
      });
    });
  });

  return dealCampaigns;
};
